<template>
    <div class="tabs">
        <el-tabs v-model="tabs" type="card" @tab-click="handleTabs">
            <el-tab-pane
                v-for="item in tabsList"
                :key="item.name"
                :label="item.label"
                :name="item.name"
            ></el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
export default {
    data() {
        return {
            tabsList: [
                { label: "院校属性", name: "attribute" },
                { label: "院校简介", name: "introduction" },
                { label: "知名导师", name: "teacher" },
                { label: "报考分析", name: "analysis" },
                { label: "附加项目", name: "condition" }
            ],
            tabs: ""
        };
    },
    computed: {},
    props: ["tabName"],
    created() {
        this.tabs = this.tabName;
    },
    methods: {
        handleTabs(tab) {
            this.$router.push(
                "/colleges/" +
                    tab.name +
                    "/" +
                    localStorage.getItem("school_uuid")
            );
            this.tabs = tab.name;
        }
    }
};
</script>

